// extracted by mini-css-extract-plugin
export default {"page__container":"cams_page__container__32pyO"};